import {createSelector} from '@reduxjs/toolkit';

const dashboardsStateSelector = (state) => state.dashboards;


export const dashboardsLoadingSelector = createSelector(dashboardsStateSelector, (dashboardsState) => dashboardsState.loading);

export const dashboardsIds = createSelector(dashboardsStateSelector, (dashboardsState) => {
    return dashboardsState && dashboardsState.ids;
});

export const dashboardsEntities = createSelector(
    dashboardsStateSelector,
    (dashboardsState) =>dashboardsState && dashboardsState.entities,
);

export const dashboardsAll = createSelector(dashboardsIds, dashboardsEntities, (ids, dashboardsEntities) =>
    ids.map((id) => dashboardsEntities[id]),
);

export const dashboardsSelected = createSelector(
    dashboardsStateSelector,
    (dashboardsState) => dashboardsState && dashboardsState.selectedDash,
);
